import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import { UrnaComponent } from './urna/urna.component';
import { IndexComponent } from './index/index.component';
import { Erro404Component } from './erro404/erro404.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { CardCandidatoComponent } from './card-candidato/card-candidato.component';
import { CartListCandidatoComponent } from './cart-list-candidato/cart-list-candidato.component';



@NgModule({
  declarations: [
    AppComponent,
    UrnaComponent,
    IndexComponent,
    Erro404Component,
    MenuComponent,
    FooterComponent,
    CardCandidatoComponent,
    CartListCandidatoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
